import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-6 grid-bg">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6 border border-[#262626] p-8" data-testid="forgot-form">
        <h2 className="font-display text-3xl font-bold tracking-tight">Reset password</h2>
        {sent ? (
          <p className="text-sm text-[#A1A1AA]">
            If an account exists for <span className="font-mono text-white">{email}</span>, a reset link has been sent.
          </p>
        ) : (
          <>
            <div>
              <Label className="text-xs uppercase tracking-wider">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 rounded-sm bg-[#141414] border-[#262626]"
                required
                data-testid="forgot-email-input"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-sm bg-[#0055FF] hover:bg-[#0044CC] text-white" data-testid="forgot-submit-btn">
              {loading ? "Sending..." : "Send reset link"}
            </Button>
          </>
        )}
        <div className="text-sm text-center">
          <Link to="/login" className="text-[#A1A1AA] hover:text-white">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
